(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aftershot-cart-drawer"]) return;
  try {
    
  (function () {
    if (window.__asCartReady) return;
    window.__asCartReady = true;
    var SECTION = 'aftershot-cart-drawer';
    var root = function () { return document.getElementById('AfterShotCart'); };
    var lastFocus = null;

    function open() {
      var el = root(); if (!el) return;
      lastFocus = document.activeElement;
      el.classList.add('is-open');
      document.documentElement.classList.add('ascd-lock');
      var panel = el.querySelector('.ascd__panel'); if (panel) panel.focus({ preventScroll: true });
    }
    function close() {
      var el = root(); if (!el) return;
      el.classList.remove('is-open');
      document.documentElement.classList.remove('ascd-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    function busy(on) { var el = root(); if (el) el.classList.toggle('is-busy', on); }

    function paint(sections) {
      var html = sections && sections[SECTION]; if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-ascd-content]');
      var current = root() && root().querySelector('[data-ascd-content]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
    function updateBubble() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('cart-icon').forEach(function (icon) {
          if (typeof icon.renderCartBubble === 'function') { try { icon.renderCartBubble(cart.item_count, true); } catch (e) {} }
        });
      }).catch(function () {});
    }
    function post(url, body) {
      body.sections = SECTION;
      body.sections_url = window.location.pathname;
      busy(true);
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw data; return data; }); })
        .then(function (data) { paint(data.sections); updateBubble(); return data; })
        .finally(function () { busy(false); });
    }
    function refresh() {
      return syncGifts().then(function () {
        return fetch(window.location.pathname + '?sections=' + SECTION).then(function (r) { return r.json(); }).then(paint);
      });
    }

    // Free gifts: keep exactly one of each gift in the cart while a qualifying variant is in it.
    // The matching automatic discounts in Shopify bring each gift to $0 at checkout.
    var syncing = false;
    function giftRules() {
      var el = document.querySelector('[data-ascd-gifts]');
      try {
        return JSON.parse(el.textContent).map(function (g) {
          return { id: g.id, needs: String(g.needs || '').split(/[^0-9]+/).filter(Boolean).map(Number) };
        });
      } catch (e) { return []; }
    }
    function syncGifts() {
      var rules = giftRules();
      if (!rules.length || syncing) return Promise.resolve();
      syncing = true;
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var have = {};
        cart.items.forEach(function (it) { have[it.variant_id] = (have[it.variant_id] || 0) + it.quantity; });
        var updates = {}, changed = false;
        rules.forEach(function (g) {
          var want = g.needs.some(function (id) { return have[id] > 0; }) ? 1 : 0;
          if ((have[g.id] || 0) !== want) { updates[g.id] = want; changed = true; }
        });
        if (changed) return post('/cart/update.js', { updates: updates });
      }).catch(function () {}).finally(function () { syncing = false; });
    }

    // Any add-to-cart form on the site opens this drawer instead of leaving the page.
    window.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1 || !root()) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var fd = new FormData(form);
      var btn = form.querySelector('[type="submit"]'); if (btn) btn.setAttribute('aria-busy', 'true');
      fd.append('sections', SECTION);
      fd.append('sections_url', window.location.pathname);
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw data; return data; }); })
        .then(function (data) { paint(data.sections); updateBubble(); open(); return syncGifts(); })
        .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to cart. Please try again.'); })
        .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
    }, true);

    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : e.target.parentElement;
      if (!t) return;
      var trigger = t.closest('[data-testid="cart-drawer-trigger"], a[href="/cart"].header-actions__action, [data-ascd-open]');
      if (trigger && root()) {
        e.preventDefault(); e.stopImmediatePropagation();
        refresh().finally(open);
        return;
      }
      if (!root() || !root().contains(t)) return;
      if (t.closest('[data-ascd-close]')) { e.preventDefault(); close(); return; }
      var q = t.closest('[data-ascd-qty]');
      if (q) {
        var item = q.closest('[data-key]');
        post('/cart/change.js', { id: item.getAttribute('data-key'), quantity: parseInt(q.getAttribute('data-ascd-qty'), 10) }).then(syncGifts);
        return;
      }
      var up = t.closest('[data-ascd-upgrade]');
      if (up) {
        var add = { id: parseInt(up.getAttribute('data-to'), 10), quantity: parseInt(up.getAttribute('data-qty'), 10) || 1 };
        if (up.getAttribute('data-plan')) add.selling_plan = parseInt(up.getAttribute('data-plan'), 10);
        post('/cart/change.js', { id: up.getAttribute('data-key'), quantity: 0 }).then(function () {
          return post('/cart/add.js', { items: [add] });
        }).then(syncGifts);
      }
    }, true);

    document.addEventListener('change', function (e) {
      var sw = e.target.closest && e.target.closest('[data-ascd-protection]');
      if (!sw) return;
      var id = root().getAttribute('data-protection-id'); if (!id) return;
      if (sw.checked) { post('/cart/add.js', { items: [{ id: parseInt(id, 10), quantity: 1 }] }); }
      else { var u = {}; u[id] = 0; post('/cart/update.js', { updates: u }); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root() && root().classList.contains('is-open')) close();
    });

    document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === SECTION) open(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === SECTION) close(); });
    // Detach the theme's own drawer from the header cart button so only this drawer opens.
    function claimTriggers() {
      document.querySelectorAll('[data-testid="cart-drawer-trigger"]').forEach(function (btn) {
        btn.removeAttribute('on:click');
        btn.setAttribute('aria-controls', 'AfterShotCart');
      });
    }
    claimTriggers();
    document.addEventListener('DOMContentLoaded', claimTriggers);
    new MutationObserver(claimTriggers).observe(document.documentElement, { childList: true, subtree: true });

    window.AfterShotCart = { open: open, close: close, refresh: refresh };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-q-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.__asqHero) return;
      root.__asqHero = true;

      /* Gallery */
      var track = root.querySelector('[data-asq-gal-track]');
      var main = root.querySelector('[data-asq-gal-main]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-asq-gal-thumb]'));
      var thumbsEl = root.querySelector('[data-asq-gal-thumbs]');
      var n = track ? track.children.length : 0;
      var idx = 0;
      var desktop = window.matchMedia('(min-width: 768px)');
      function go(i) {
        if (!n) return;
        idx = ((i % n) + n) % n;
        track.style.transform = 'translateX(-' + idx * 100 + '%)';
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); t.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
        if (thumbsEl && thumbs[0]) {
          var win = thumbsEl.parentElement;
          if (desktop.matches) {
            var step = thumbs[0].offsetHeight + 13;
            var maxY = Math.max(0, thumbsEl.scrollHeight - win.clientHeight);
            thumbsEl.style.transform = 'translateY(-' + Math.min(idx * step, maxY) + 'px)';
          } else {
            var stepX = thumbs[0].offsetWidth + 7;
            var maxX = Math.max(0, thumbsEl.scrollWidth - win.clientWidth);
            thumbsEl.style.transform = 'translateX(-' + Math.min(idx * stepX, maxX) + 'px)';
          }
        }
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-asq-gal-thumb')); }); });
      var prev = root.querySelector('[data-asq-gal-prev]');
      var next = root.querySelector('[data-asq-gal-next]');
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      if (main) {
        var start = null;
        main.addEventListener('pointerdown', function (e) { start = { x: e.clientX, y: e.clientY }; });
        main.addEventListener('pointerup', function (e) {
          if (!start) return;
          var dx = e.clientX - start.x, dy = e.clientY - start.y;
          start = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1));
        });
        main.addEventListener('pointercancel', function () { start = null; });
      }
      if (desktop.addEventListener) desktop.addEventListener('change', function () { go(idx); });

      /* Delivery window: today + min/max days */
      var eta = root.querySelector('[data-asq-eta]');
      if (eta) {
        var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
        var now = new Date();
        var a = new Date(now.getTime() + (+eta.getAttribute('data-min') || 7) * 864e5);
        var b = new Date(now.getTime() + (+eta.getAttribute('data-max') || 15) * 864e5);
        var tpl = eta.getAttribute('data-template') || '';
        if (tpl) eta.innerHTML = tpl.replace('[from]', '<b>' + fmt(a) + '</b>').replace('[to]', '<b>' + fmt(b) + '</b>');
      }

      /* Bundles, subscription toggle, gifts, button */
      var btn = root.querySelector('[data-asq-btn]');
      var label = root.querySelector('[data-asq-btn-label]');
      var bPrice = root.querySelector('[data-asq-btn-price]');
      var bWas = root.querySelector('[data-asq-btn-was]');
      var sp = root.querySelector('[data-asq-sp]');
      var toggle = root.querySelector('[data-asq-toggle]');
      var atcLabel = label ? label.textContent : '';
      var gifts = root.querySelectorAll('[data-asq-gift]');
      function isSub(r) { return root.getAttribute('data-mode') === 'sub' && r.getAttribute('data-sp'); }
      function sync() {
        root.querySelectorAll('input[name="id"]').forEach(function (r) {
          var t = r.closest('.asq-tier'); if (!t) return;
          var sub = isSub(r);
          var p = t.querySelector('[data-asq-price]'); if (p) p.textContent = sub ? r.getAttribute('data-sp-price') : r.getAttribute('data-price');
          var w = t.querySelector('[data-asq-was]'); if (w) w.textContent = (sub ? r.getAttribute('data-price') : r.getAttribute('data-compare')) || '';
          var pn = t.querySelector('[data-asq-pn]'); if (pn) pn.textContent = sub ? pn.getAttribute('data-sub') : pn.getAttribute('data-once');
        });
        var r = root.querySelector('input[name="id"]:checked');
        if (!r) return;
        var sub = isSub(r);
        root.setAttribute('data-tier', r.getAttribute('data-pos'));
        if (sp) sp.value = sub ? r.getAttribute('data-sp') : '';
        var ok = r.getAttribute('data-available') === 'true';
        if (btn) btn.disabled = !ok;
        if (label) label.textContent = ok ? atcLabel : btn.getAttribute('data-soldout');
        if (bPrice) bPrice.textContent = sub ? r.getAttribute('data-sp-price') : r.getAttribute('data-price');
        if (bWas) bWas.textContent = (sub ? r.getAttribute('data-price') : r.getAttribute('data-compare')) || '';
        if (toggle) {
          toggle.textContent = sub
            ? toggle.getAttribute('data-once-label') + ' - ' + r.getAttribute('data-price') + ' ' + toggle.getAttribute('data-once-suffix')
            : toggle.getAttribute('data-sub-label') + (r.getAttribute('data-sp') ? ' - ' + r.getAttribute('data-sp-price') : '');
        }
        var pos = +r.getAttribute('data-pos');
        gifts.forEach(function (g) { g.classList.toggle('is-locked', pos < +g.getAttribute('data-min')); });
      }
      if (toggle) toggle.addEventListener('click', function () {
        root.setAttribute('data-mode', root.getAttribute('data-mode') === 'sub' ? 'once' : 'sub');
        sync();
      });
      root.querySelectorAll('input[name="id"]').forEach(function (r) { r.addEventListener('change', sync); });
      sync();

      /* Accordions: one open at a time */
      var accs = root.querySelectorAll('[data-asq-acc]');
      accs.forEach(function (h) {
        h.addEventListener('click', function () {
          var item = h.parentElement;
          var open = !item.classList.contains('is-open');
          accs.forEach(function (o) { o.parentElement.classList.remove('is-open'); o.setAttribute('aria-expanded', 'false'); });
          if (open) { item.classList.add('is-open'); h.setAttribute('aria-expanded', 'true'); }
        });
      });
    }
    function boot() { document.querySelectorAll('[data-asq-hero]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-q-sticky"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(bar) {
      if (!bar || bar.__asqSticky) return;
      bar.__asqSticky = true;
      var go = bar.querySelector('[data-asq-sticky-go]');
      var targetId = go ? go.getAttribute('href').slice(1) : 'buy';
      var buyBtn = document.querySelector('[data-asq-btn]') || document.getElementById(targetId);
      if (!buyBtn || !('IntersectionObserver' in window)) return;
      function set(on) {
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        bar.querySelectorAll('[data-asq-sticky-go]').forEach(function (a) { a.tabIndex = on ? 0 : -1; });
      }
      /* Shown only once the buy button has scrolled out past the top (never before reaching it). */
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        set(!e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(buyBtn);
      bar.querySelectorAll('[data-asq-sticky-go]').forEach(function (a) {
        a.addEventListener('click', function (ev) {
          var target = document.getElementById(targetId);
          if (!target) return;
          ev.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          /* Horizon scrolls inside .page-wrapper and some contexts ignore smooth scroll: force the jump if nothing moved. */
          var before = target.getBoundingClientRect().top;
          setTimeout(function () {
            if (Math.abs(target.getBoundingClientRect().top - before) < 2 && Math.abs(before) > 4) target.scrollIntoView({ block: 'start' });
          }, 500);
        });
      });
    }
    function boot() { document.querySelectorAll('[data-asq-sticky]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
